module.exports = __webpack_public_path__ + "static/img/img2.c927c50.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/image/img2.png
// module id = FL8Q
// module chunks = 1